export default __webpack_public_path__ + "static/media/2.59059032.jpg";